import React, {Component} from 'react'

import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Chip from '@material-ui/core/Chip'

import AddTemplateIcon from '@material-ui/icons/AddCircle'

import PaperBlock from "../../../ui/PaperBlock"

import withStyles from '@material-ui/core/styles/withStyles'

/**
 * <TemplatesPanel templates onSelectTemplateClick = {} onRemoveTemplateClick = {template}/>
 */

class TemplatesPanel extends Component {

	render() {
		const {classes} = this.props
		return <PaperBlock 
			style = {{padding: "0px", display: "flex", flexDirection: "column"}}
		>
			<div style={{margin: "10px"}}>
				<div style = {{width: "100%", display: "flex", alignItems: "center"}}>
					<Typography style = {{flex: "1 1 auto"}}>Шаблоны</Typography>
					<Button
						onClick = {e => {
							e.stopPropagation()
							if (typeof this.props.onSelectTemplateClick === "function") {
								this.props.onSelectTemplateClick()
							}
						}}
					><AddTemplateIcon className = {classes.AddTemplateIcon}/>Добавить шаблон</Button>
				</div>
				<div style = {{display: "flex", flexWrap: "wrap"}}>
					{this.props.templates.map(
						(template, n) => <Chip
							className = {classes.Chip}
							key = {n}
							label = {`${template.name} (${parseInt(template.amount)})`}
							onDelete = {() => {
								if (typeof this.props.onRemoveTemplateClick) {
									this.props.onRemoveTemplateClick(template)
								}
							}}
						/>
					)}
				</div>
			</div>
		</PaperBlock>
	}

}

export default withStyles(theme => ({
	AddTemplateIcon: {
		marginRight: theme.spacing.unit,
	},
	Chip: {
		margin: theme.spacing.unit,
	}
}))(TemplatesPanel)
